var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"fab":"","disabled":_vm.disabledAddContact,"small":"","bottom":"","color":"primary"}},[_c('v-icon',{attrs:{"size":"28"},on:{"click":function($event){return _vm.addContact()}}},[_vm._v(" mdi-plus ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }